// src/pages/AdvanceCustomerBalance/components/exportAdvanceCustomerBalanceCsv.js

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtNum = (val) => Number(val || 0).toFixed(2);

/**
 * @param {object} params
 * @param {Array}   params.list      - rows from Redux state.advanceCustomerBalance.list
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportAdvanceCustomerBalanceCsv = ({
  list,
  title = "Advance Debtor / Customer Balance Report",
  filename = "advance_customer_balance",
}) => {
  const headers = [
    "No.", "Customer Name", "Contact No", "Address",
    "Received", "Payment", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.customerName || "",
    row.contactNo    || "",
    row.address      || "",
    fmtNum(row.received),
    fmtNum(row.payment),
    fmtNum(row.balance),
  ].map(escape));

  const totals = list.reduce(
    (acc, row) => ({
      received: acc.received + Number(row.received || 0),
      payment:  acc.payment  + Number(row.payment  || 0),
      balance:  acc.balance  + Number(row.balance  || 0),
    }),
    { received: 0, payment: 0, balance: 0 }
  );

  const totalRow = [
    "Grand Total", "", "", "",
    fmtNum(totals.received),
    fmtNum(totals.payment),
    fmtNum(totals.balance),
  ].map(escape);

  const rows = [
    [title],
    [],
    headers,
    ...dataRows,
    [],
    totalRow,
  ];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};